import { ISelectOption } from '../../../UIPackage/MainModule/components/SelectInput';
import { IKnmErknmFormDocTarget } from '../../../KnmErknmPackage/MainModule/interfaces/IKnmErknmFormDocTarget';
import { IDictionarySelectOption } from '../../../CorePackage/DictionariesModule/interfaces/IDictionarySelectOption';
import { IPermitDocs } from '../../../APIPackage/DictionariesModule/interfaces/IPermitDocs';

export const DocTypeLabelsEnum: { [index: string]: string } = {
  PERMITTED: 'Разрешительный документ',
  OTHER: 'Иной документ',
};

/**
 * Возвращает объект опции для селекта с выбором типа документа
 */
export const getDocTypeOption = (type: string): ISelectOption => {
  return {
    id: type,
    label: DocTypeLabelsEnum[type],
    value: type,
  };
};

/**
 * Получение списка документов
 */
export const getDocTargetOptions = (
  selectedFields: (string | undefined)[],
  fieldValue: IKnmErknmFormDocTarget,
  docOptions: IDictionarySelectOption<IPermitDocs>[] | undefined,
): IDictionarySelectOption<IPermitDocs>[] | undefined => {
  return docOptions?.filter(option => {
    return !selectedFields.includes(option.targetTitle) && option.type === fieldValue?.docTargetType?.value;
  });
};

/**
 * Получение списка типов документов
 */
export const getDocTargetTypeOptions = (
  docOptions: IDictionarySelectOption<IPermitDocs>[] | undefined,
): ISelectOption[] => {
  const types = [...new Set(docOptions?.map(option => option.type))];

  return types.map(type => {
    return getDocTypeOption(type);
  });
};

/**
 * Возвращает значение селекта выбора типа документа
 */
export const getDocTargetType = (
  docOptions: IDictionarySelectOption<IPermitDocs>[] | undefined,
): ISelectOption | undefined => {
  const types = getDocTargetTypeOptions(docOptions);

  if (docOptions?.length === 1) {
    return getDocTypeOption(docOptions[0].type);
  }
  if (types.length === 1) {
    return types[0];
  }

  return undefined;
};
